<template>
  <div class="engineering">
    <div class="contentDiv1">
      <van-search v-model="seachValue" :show-action="showAction" placeholder="请输入关键字" @input="sousuoInput" />
      <MyPageHeader ref="pageHeader" :menu="dataList" @menu-change="handleEngineeringChange"></MyPageHeader>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false"
      style="height:65vh;overflow:auto">
      <van-swipe-cell v-for="( item, index ) in  TreeList " :key="index">
        <div class="contentDiv2 flexLR" @click="onClickTabs(item)">
          <div class="flexLR" style="width: 90%; justify-content: start">
            <div>
              <img v-if="item.pftr02" style="display: block; margin-right: 10px" src="../../../assets/mobileImg/文件夹.png"
                alt="" />
              <img v-else style="display: block; margin-right: 10px" src="../../../assets/mobileImg/文件.png" alt="" />
            </div>
            <div>{{
              item.pftr02 ? item.pftr02 : item.prfl02
            }}</div>
          </div>
          <van-icon name="arrow" v-show="item.pftr02 ? true : false" />
        </div>

      </van-swipe-cell>
    </van-list>
  </div>
</template>


<script>
import { Col, ImagePreview } from "vant";
import MyPageHeader from "@/components/PageHeader";
import {
  GetProjectFileZTree, GetDataFileList, DelDataFile, ViewDrawings, TransformDrawings
} from "@/api/index";
export default {
  name: "engineering",
  components: {
    MyPageHeader,
  },
  data() {
    return {
      loading: false,
      finished: false,
      pageSize: 0,
      seachValue: '',
      showAction: false,
      informList: [],
      TreeList: [],
      CacheTreeList: [],
      ids: "",
      dataList: [
        {
          title: this.$route.query.title,
          id: 0,
        }
      ],
      zNodes: [],
      treeids: null,
      infoList: [],
      tips: null,
    };
  },
  computed: {},
  watch: {
  },
  methods: {
    // 面包屑发生改变
    handleEngineeringChange(data) {
      this.dataList = data;
      if (this.dataList[this.dataList.length - 1].title === '工程资料') {
        this.getData()
      } else {
        this.treeids = this.dataList[this.dataList.length - 1].id;
        this.getData(this.dataList[this.dataList.length - 1])
      }

    },
    onClickTabs(v) {
      if (v.prfl02) {
        this.wxClick(v)
      } else {
        this.dataList.push({ title: v.pftr02, id: v.pftr01 })
        this.treeids = v.pftr01;
        this.getData(v)
      }
    },
    wxClick(item) {
      if (item.prfl02.includes('dwg')) {
        this.tips = null;
        let id = item.prfl01;
        ViewDrawings({ id }).then(async (res) => {
          if (res.Code == 0) {
            this.tips = this.$Notify({
              type: "success",
              message: res.Message,
              duration: 0,
            });
            // 
            let params = {
              qid: this.$store.state.qid,
              id,
            };
            var res = await TransformDrawings(params);
            if (res.Code == 0) {
              this.$Notify({ type: "warning", message: res.Message });
              this.tips.Close();
            } else {
              this.$Notify({
                message: res.Message,
                type: "success",
              });
              this.tips.onClose();
              this.showModel(res.Data);
            }
          } else if (res.Code == 1) {
            this.$Notify({ type: "warning", message: res.Message });
          } else if (res.Code == 2) {
            this.showModel(res.Data);
          }
        });
      } else {
        this.$router.push({ name: "fileinfo", params: { ...item }, query: { name: item.prfl02, item: item }, });
      }

    },
    showModel(item) {
      this.$router.push({
        name: "fileinfo", params: { ...item }, query: { name: item.pjdr03, item: item, },
      });
    },
    sousuoInput(val) {
      if (val == "") {
        this.TreeList = this.CacheTreeList;
      } else {
        this.TreeList = this.CacheTreeList.filter(w => w.prfl02 && w.prfl02.includes(val) || w.pftr02 && w.pftr02.includes(val));
      }
    },
    async getData(data) {
      let res = await GetProjectFileZTree({
        params: {
          xid: this.$store.state.pid,
        },
      });
      let ids = res.Data.reduce((a, b, k) => {
        b["is"] = false;
        return a + b.pftr01 + (res.Data.length - 1 == k ? "" : ",");
      }, "");
      // 树节点下的文件
      GetDataFileList({
        params: {
          seachword: this.seachValue,
          xid: this.$store.state.pid,
          uid: this.$store.state.uid,
          gid: this.treeids,
          type: 1,
          pageIndex: 1,
          pageSize: 99999,
        },
      }).then((res1) => {
        if (data) {//图纸文件
          if (data.title && data.id === 1 || data.title && data.id === 2) {
            this.TreeList = res.Data.filter((w) => w.pftr03 === 0)
          } else {
            this.TreeList = res.Data.filter((w) => w.pftr03 === this.treeids)
            this.informList = res1.Data.list.filter((w) => w.prfl06 === this.treeids)
            this.TreeList = this.TreeList.concat(this.informList);
          }
        } else {//第一次
          this.TreeList = res.Data.filter((w) => w.pftr03 === 0)
        }
        this.CacheTreeList = JSON.parse(JSON.stringify(this.TreeList))
      })
      this.loading = false;
      this.finished = true;
    },
  },
  created() { },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.engineering {
  width: 100%;
  height: 95vh;
  margin: 0 auto;

  .contentDiv1 {
    width: 100%;
    height: 180px;
    background-color: white;
    margin-bottom: 20px;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 6;
  }

  .contentDiv2 {
    height: 100px;
    padding: 20px 40px;
    background-color: white;
    margin-bottom: 5px;
  }

  /deep/ .van-tabs {
    height: 80vh;
  }

  /deep/.van-tab__pane {
    height: 100%
  }

  /deep/ .van-tabs__line {
    background-color: rgb(255, 255, 255);
  }

  /deep/ .van-tabs__nav {
    background-color: rgba(255, 255, 255, 0);
  }

  .engineeringSpan {
    color: white;
  }

  /deep/ .van-tab__text {
    padding: 0 10px;
  }

  /deep/ .van-tab--active .van-tab__text .engineeringSpan {
    position: relative;
    z-index: 1;
    min-width: 62px;
    text-align: center;
    display: block;
    color: rgb(0, 119, 255);

    &::after {
      content: "";
      position: absolute;
      left: -5px;
      z-index: -1;
      top: 0;
      background-color: rgb(255, 255, 255);
      width: 100%;
      padding: 0 5px;
      border-radius: 10px;
      height: 100%;
    }
  }

  /deep/ .van-tabs__content {
    height: 93%;
    overflow: hidden;
    overflow-y: auto;
  }
}

.headTree {
  width: 100%;
  height: 40px;
  overflow: hidden;
  overflow-y: auto;
  background-color: red;
}
</style>
